module.exports = __webpack_public_path__ + "static/media/ae5.12d550a7.png";